var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-header',{attrs:{"id":"app-header"}},[_c('a-icon',{staticClass:"sidebar-trigger",attrs:{"type":_vm.type},on:{"click":_vm.onBurgerClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }